import React, {useState, useEffect} from 'react';
import Layout from '../../components/Layout/Layout.js';
import AdminMenu from '../../components/Layout/AdminMenu.js';
import toast from 'react-hot-toast';
import axios from 'axios';
import {Select} from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import '../../styles/AdminStyles.css';
const {Option} = Select;

const UpdateProduct = () => {
    const navigate = useNavigate();
    const params = useParams();
    const [categories, setCategories] = useState([]);
    const[name,setName] = useState("");
    const[description,setDescription] = useState("");
    const[price,setPrice] = useState("");
    const[category,setCategory] = useState("");
    const[quantity,setQuantity] = useState("");
    const[shipping,setShipping] = useState("");
    const[photo,setPhoto] = useState("");
    const [id,setId] = useState("");

  const getSingleProduct= async () => {
    try {
        const {data} = await axios.get(`/api/v1/products/get-product/${params.slug}`);
        setName(data.product.name);
        setId(data.product._id);
        setDescription(data.product.description);
        setPrice(data.product.price);
        setCategory(data.product.category._id);
        setQuantity(data.product.quantity);
        setShipping(data.product.shipping);
    } catch (error) {
        console.log(error);
    }
  };
  useEffect(() =>{
    getSingleProduct();
    //eslint-disable-next-line
  },[]);

  const getAllCategory = async() => {
    try {
      const {data} = await axios.get('/api/v1/category/get-category');
      if (data?.success) {
        setCategories(data?.category);
      }
    } catch (error) {
      console.log(error);
      toast.error('حدث خطأ في جلب الأقسام');
    }
  };
  useEffect(() => {
    getAllCategory();
  },[]);

  const handleUpdate = async (e) => {
    e.preventDefault();
    try {
      const productData = new FormData();
      productData.append("name",name);
      productData.append("description",description);
      productData.append("price",price);
      productData.append("category",category);
      productData.append("quantity",quantity);
      productData.append("shipping",shipping);
      photo && productData.append("photo",photo);
      await axios.put(`/api/v1/products/update-product/${id}`, productData);
      toast.success('تم تحديث المنتج بنجاح');
      navigate('/dashboard/admin/products');
    } catch (error) {
      console.log(error);
      toast.error('حدث خطأ ما');
    }
  };

  const handleDelete = async() => {
    try {
        let answer = window.prompt('هل أنت متأكد من حذف هذا المنتج؟');
        if (!answer) return;
        await axios.delete(`/api/v1/products/delete-product/${id}`);
        toast.success('تم حذف المنتج بنجاح');
        navigate('/dashboard/admin/products');
    } catch (error) {
        console.log(error);
        toast.error('حدث خطأ ما');
    }
  };

  return (
    <Layout title={'تحديث المنتج - النخبة ستور'}>
      <div className='container-fluid admin-layout'>
        <div className='row'>
          <div className='col-md-3'>
            <AdminMenu/>
          </div>
          <div className='col-md-9'>
            <div className="admin-page-header">
              <h1>تحديث المنتج</h1>
              <p>تعديل بيانات المنتج أو حذفه</p>
              <div className="admin-page-header-line"></div>
            </div>

            <div className='admin-form-card'>
              <div className='mb-3'>
                <label>القسم</label>
                <Select bordered={false}
                  placeholder='اختر القسم'
                  size='large'
                  showSearch
                  className='form-select'
                  onChange={(value) => setCategory(value)}
                  value={category}>
                  {categories?.map((c) => (
                    <Option key={c._id} value={c._id}>{c.name}</Option>
                  ))}
                </Select>
              </div>

              <div className='mb-3'>
                <label className="admin-upload-btn">
                  📷 {photo ? photo.name : "تغيير صورة المنتج"}
                  <input type="file" name='photo' accept='image/*' onChange={(e) => setPhoto(e.target.files[0])} hidden />
                </label>
              </div>

              <div className='mb-3 text-center'>
                {photo ? (
                  <img src={URL.createObjectURL(photo)} alt="صورة المنتج" className="admin-preview-img" />
                ) : (
                  <img src={`/api/v1/products/product-photo/${id}`} alt="صورة المنتج" className="admin-preview-img" />
                )}
              </div>

              <div className='mb-3'>
                <label>اسم المنتج</label>
                <input type='text' value={name} placeholder='اسم المنتج' className='form-control' onChange={(e) => setName(e.target.value)} />
              </div>

              <div className='mb-3'>
                <label>وصف المنتج</label>
                <textarea rows={"4"} value={description} placeholder='وصف المنتج' className='form-control' onChange={(e) => setDescription(e.target.value)} />
              </div>

              <div className='row'>
                <div className='col-md-6 mb-3'>
                  <label>السعر (د.ع)</label>
                  <input type='number' value={price} placeholder='السعر' className='form-control' onChange={(e) => setPrice(e.target.value)} />
                </div>
                <div className='col-md-6 mb-3'>
                  <label>الكمية</label>
                  <input type='number' value={quantity} placeholder='الكمية' className='form-control' onChange={(e) => setQuantity(e.target.value)} />
                </div>
              </div>

              <div className='mb-3'>
                <label>الشحن</label>
                <Select bordered={false} placeholder="الشحن" size='large' showSearch className='form-select' onChange={(value) => setShipping(value)} value={shipping ? "نعم":"لا"}>
                  <Option value="0">لا</Option>
                  <Option value="1">نعم</Option>
                </Select>
              </div>

              <div className='d-flex gap-3 mt-3'>
                <button className='btn btn-gold-shimmer flex-grow-1' onClick={handleUpdate}>
                  ✏️ تحديث المنتج
                </button>
                <button className='btn btn-danger' onClick={handleDelete}>
                  🗑️ حذف
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default UpdateProduct;
